import { render, staticRenderFns } from "./RepoView.vue?vue&type=template&id=6885a059&"
import script from "./RepoView.vue?vue&type=script&lang=ts&"
export * from "./RepoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports